import script from "./CriterionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CriterionForm.vue?vue&type=script&setup=true&lang=ts"

import "./CriterionForm.vue?vue&type=style&index=0&id=3b1ec148&lang=scss"

const __exports__ = script;

export default __exports__